<script setup>
import { ref } from 'vue'
import { DxList } from 'devextreme-vue'

const listComponent = ref(null)
const props = defineProps({
  dataSource: {
    type: Array,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  applyFilter: {
    type: Function,
    required: true
  },
  gridRef: {
    type: Object,
    required: true
  },
  mainFilter: {
    type: Object,
    default: null
  },
})

const onSelectionChanged = (e, data) => {
  const selectedItemKeys = e.component.option('selectedItemKeys') || []
  const resolved = Array.from(new Set(selectedItemKeys.map(item => item !== null && typeof item === 'object' ? item.id : item)))
  data.component.option('value', resolved)
  props.applyFilter(resolved, props.field, props.gridRef, props.mainFilter)
}

const clearFilter = () => {
  props.applyFilter([], props.field, props.gridRef, props.mainFilter)

  if (listComponent.value && listComponent.value.instance) {
    listComponent.value.instance.unselectAll()
  }
}

const setSelectedItemKeys = (selectedItemKeys) => {
  const currentSelectedItemKeys = listComponent.value?.instance?.option('selectedItemKeys') || []
  const hasSameSelection = currentSelectedItemKeys.length === selectedItemKeys.length && currentSelectedItemKeys.every(key => selectedItemKeys.includes(key))

  if (!hasSameSelection) {
    listComponent.value?.instance?.option('selectedItemKeys', selectedItemKeys)
  }
}

defineExpose({ clearFilter, setSelectedItemKeys })
</script>

<template>
  <dx-list
    ref="listComponent"
    :data-source="props.dataSource"
    display-expr="name"
    key-expr="id"
    :show-selection-controls="true"
    selection-mode="multiple"
    :select-by-click="true"
    :show-select-all-checkbox="false"
    :grouped="true"
    @selection-changed="e => onSelectionChanged(e, $attrs.data)"
  >
    <template #groupTemplate="{ data: groupData }">
      <div
        v-if="groupData.key"
        class="group-header"
      >
        {{ groupData.key }}
      </div>
    </template>
  </dx-list>
</template>
